import React from 'react';
import { TooltipRenderProps } from 'react-joyride';

export function CustomTooltip({
  index,
  step,
  backProps,
  closeProps,
  primaryProps,
  skipProps,
  tooltipProps,
  isLastStep,
}: TooltipRenderProps) {
  return (
    <div
      {...tooltipProps}
      className="bg-white dark:bg-gray-900 rounded-2xl shadow-2xl w-[320px] md:w-[380px] overflow-hidden border border-gray-100 dark:border-gray-800 relative z-[10000]"
    >
      {/* Colorful top gradient border */}
      <div className="h-1.5 w-full bg-gradient-to-r from-pink-500 via-purple-500 to-indigo-500" />
      
      <div className="p-5 md:p-6">
        {step.title && (
          <h3 className="text-lg font-bold text-gray-900 dark:text-white mb-2 tracking-tight">
            {step.title}
          </h3>
        )}
        <div className="text-gray-600 dark:text-gray-300 text-sm leading-relaxed mb-6">
          {step.content}
        </div>
        
        <div className="flex items-center justify-between">
          <div className="flex gap-2">
            {!isLastStep && (
              <button
                {...skipProps}
                className="text-xs font-medium text-gray-400 hover:text-gray-600 dark:hover:text-gray-300 transition-colors py-2 px-1"
              >
                Skip tour
              </button>
            )}
          </div>
          
          <div className="flex items-center gap-2">
            {index > 0 && (
              <button
                {...backProps}
                className="px-3 py-1.5 rounded-lg text-sm font-medium text-gray-600 dark:text-gray-300 bg-gray-100 dark:bg-gray-800 hover:bg-gray-200 dark:hover:bg-gray-700 transition-colors"
              >
                Back
              </button>
            )}
            <button
              {...primaryProps}
              className="px-4 py-1.5 rounded-lg text-sm font-medium text-white bg-gradient-to-r from-[#FAA61A] to-[#ffb84d] hover:from-[#e59416] hover:to-[#e6a545] shadow-md shadow-orange-500/20 transition-all transform hover:scale-[1.02] active:scale-[0.98]"
            >
              {isLastStep ? 'Finish' : 'Next'}
            </button>
          </div>
        </div>
      </div>
      
      {/* Close Button at top right */}
      <button
        {...closeProps}
        className="absolute top-3 right-3 text-gray-400 hover:text-gray-600 dark:hover:text-gray-200 transition-colors p-1 bg-gray-50/50 dark:bg-gray-800/50 rounded-full hover:bg-gray-100 dark:hover:bg-gray-700"
        aria-label="Close"
      >
        <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
        </svg>
      </button>
    </div>
  );
}
